<template>
    <form method="POST" :action="route('therapy.store', consultation)" enctype="multipart/form-data" data-unsaved-guard autocomplete="on">
        <input type="hidden" name="_token" :value="csrf" />
        <!-- @csrf -->
        <!-- Bolesti opcije -->
        <div class="col mb-3">
            <div class="card shadow-sm">
                <h5 class="card-header bg-disease text-white">
                    <ul class="list-inline m-0 d-flex align-items-center">
                        <li class="list-inline-item">
                            Bolesti
                        </li>
                        <li class="list-inline-item">
                            <a @click="addDisease" id="add-disease" data-toggle="tooltip" title="Dodaj novu bolest (Alt+B)"><i class="bi bi-plus-circle"></i></a>
                        </li>
                        <li class="list-inline-item ms-auto">
                            <kbd class="bg-white text-dark opacity-75 rounded px-1" style="font-size:.65rem">Alt+B</kbd>
                        </li>
                    </ul>
                </h5>
                <div class="card-body text-muted">
                    <draggable v-model="form.diseases" item-key="_key" handle=".drag-handle">
                        <template #item="{element: disease, index}">
                            <div class="diseases" :id="`diseases[${index}]`">
                                <div class="row g-3 mb-2">
                                    <div class="col">
                                        <div class="row g-2">
                                            <div class="col-12">
                                                <div class="form-floating">
                                                    <input
                                                        :id="`diseases[${index}][disease]`"
                                                        :name="`diseases[${index}][disease]`"
                                                        v-model="disease.disease"
                                                        type="text"
                                                        class="form-control text-disease"
                                                        placeholder="Bolest"
                                                        @input="debouncedFindDisease(index)"
                                                        @keydown="onDiseaseKeydown($event, index)"
                                                        required
                                                    />
                                                    <label>Bolest</label>
                                                </div>
                                            </div>
                                            <div
                                                class="col-12"
                                                v-if="
                                                    (filteredDiseases[index] && filteredDiseases[index].length) &&
                                                    (form.diseases[index].disease != '' || form.diseases[index].disease != null)
                                                "
                                            >
                                                <ul class="list-group">
                                                    <li
                                                        v-for="(suggestedDisease, idx) in filteredDiseases[index]"
                                                        :key="`diseases[${index}][${suggestedDisease}]`"
                                                        @click="selectDisease(index, suggestedDisease)"
                                                        :class="['list-group-item list-group-item-action list-group-item-light d-flex justify-content-between align-items-start', { active: highlightedDisease[index] === idx }]"
                                                        style="cursor: pointer;"
                                                    >
                                                        {{ suggestedDisease.name }}
                                                        <span class="badge bg-secondary text-disease rounded-pill">{{ suggestedDisease.MKB10 }}</span>
                                                    </li>
                                                    <li
                                                        class="list-group-item list-group-item-action list-group-item-light text-danger"
                                                        @click="clearDisease(index)"
                                                        style="cursor: pointer;"
                                                    >
                                                        <i class="bi bi-arrow-up-circle"></i> Zatvori <kbd class="ms-1" style="font-size:.65rem">Esc</kbd>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <div class="form-floating">
                                            <input
                                                :id="`diseases[${index}][MKB10]`"
                                                :name="`diseases[${index}][MKB10]`"
                                                v-model="disease.MKB10"
                                                type="text"
                                                placeholder="MKB-10"
                                                class="form-control"
                                            />
                                            <label>MKB-10</label>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <div class="form-floating">
                                            <input
                                                :id="`diseases[${index}][MKB11]`"
                                                :name="`diseases[${index}][MKB11]`"
                                                v-model="disease.MKB11"
                                                type="text"
                                                placeholder="MKB-11"
                                                class="form-control"
                                            />
                                            <label>MKB-11</label>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-floating">
                                            <select
                                                :id="`diseases[${index}][therapy_goal_achieved]`"
                                                :name="`diseases[${index}][therapy_goal_achieved]`"
                                                v-model="disease.therapy_goal_achieved"
                                                class="form-select w-100"
                                            >
                                            <option value=""></option>
                                            <option value="Ne">Ne</option>
                                            <option value="Da">Da</option>
                                            <option value="Nije primjenjivo">Nije primjenjivo</option>
                                            </select>
                                            <label data-toggle="tooltip" title="Terapijski cilj postignut">Terapijski cilj postignut</label>
                                        </div>

                                    </div>
                                    <div class="col-md-auto align-self-center text-center">
                                        <div class="d-flex flex-column gap-1 align-items-center">
                                            <span class="drag-handle text-secondary fs-5" style="cursor: grab;" title="Povuci za promjenu redoslijeda"><i class="bi bi-grip-vertical"></i></span>
                                            <a @click="removeDisease(index)" class="text-danger" style="cursor: pointer;" title="Ukloni bolest"><i class="bi bi-dash-circle"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                    <div class="row">
                        <div class="col ">
                            <div class="form-floating">
                                <textarea id="history" type="text" style="height: 100px" class="form-control" name="history" v-model="form.history"></textarea>
                                <label>Povijest bolesti</label>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col">
                            <div class="form-floating">
                                <textarea id="relevant_medical_history" type="text" style="height: 100px" class="form-control" name="relevant_medical_history" v-model="form.relevant_medical_history"></textarea>
                                <label>Relevantna medikacijska povijest</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col mb-3">
            <div class="card shadow-sm">
                <h5 class="card-header bg-medicine text-white">
                    <ul class="list-inline m-0 d-flex align-items-center">
                        <li class="list-inline-item">
                            Lijekovi
                        </li>
                        <li class="list-inline-item">
                            <a @click="addMedicine" id="add-medicine" data-toggle="tooltip" title="Dodaj novi lijek (Alt+L)"><i class="bi bi-plus-circle"></i></a>
                        </li>
                        <li class="list-inline-item ms-auto">
                            <kbd class="bg-white text-dark opacity-75 rounded px-1" style="font-size:.65rem">Alt+L</kbd>
                        </li>
                    </ul>
                </h5>
                <div class="card-body text-muted bg-white">
                    <draggable v-model="form.medicines" item-key="_key" handle=".drag-handle">
                        <template #item="{element: medicine, index}">
                            <div class="medicine" :id="`medicines-[${index}]`">
                                <div class="row g-2 mb-2">
                                    <div class="col-md">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="form-floating">
                                                    <textarea
                                                        class="form-control text-medicine"
                                                        type="text"
                                                        :name="`medicines[${index}][drug]`"
                                                        v-model="medicine.drug"
                                                        data-toggle="tooltip"
                                                        title="Lijek koji se propisuje"
                                                        placeholder="Lijek"
                                                        @input="debouncedFindDrug(index)"
                                                        @keydown="onDrugKeydown($event, index)"
                                                        required
                                                    ></textarea>
                                                    <label>Lijek</label>
                                                </div>
                                            </div>
                                            <div
                                                class="col-12"
                                                v-if="
                                                    (filteredDrugs[index] && filteredDrugs[index].length) &&
                                                    (form.medicines[index].drug != '' || form.medicines[index].drug != null)
                                                "
                                            >
                                                <ul class="list-group">
                                                    <li
                                                        v-for="(suggestedDrug, idx) in filteredDrugs[index]"
                                                        :key="`medicines[${index}][${suggestedDrug}]`"
                                                        @click="selectDrug(index, suggestedDrug)"
                                                        :class="['list-group-item list-group-item-action list-group-item-light d-flex justify-content-between align-items-start', { active: highlightedDrug[index] === idx }]"
                                                        style="cursor: pointer;"
                                                    >
                                                        {{ suggestedDrug.name }}
                                                        <span class="badge rounded-pill bg-secondary text-medicine">{{ suggestedDrug.ATK }}</span>
                                                    </li>
                                                    <li
                                                        class="list-group-item list-group-item-action list-group-item-light text-danger"
                                                        @click="clearDrug(index)"
                                                        style="cursor: pointer;"
                                                    >
                                                        <i class="bi bi-arrow-up-circle"></i> Zatvori <kbd class="ms-1" style="font-size:.65rem">Esc</kbd>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-floating">
                                            <textarea
                                                type="text"
                                                :name="`medicines[${index}][ATK]`"
                                                v-model="medicine.ATK"
                                                class="form-control"
                                                data-toggle="tooltip"
                                                title="ATK klasifikacija"
                                                placeholder="ATK"
                                            ></textarea>
                                            <label>ATK</label>
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-floating">
                                            <textarea
                                                type="text"
                                                class="form-control"
                                                :name="`medicines[${index}][scheme]`"
                                                v-model="medicine.scheme"
                                                data-toggle="tooltip"
                                                title="Doza / Vrijeme uzimanja / S hranom ili natašte / Način uzimanja)"
                                                placeholder="Shema doziranja"
                                            ></textarea>
                                            <label>Shema doziranja</label>
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-floating">
                                            <textarea
                                                type="text"
                                                class="form-control"
                                                :name="`medicines[${index}][length]`"
                                                v-model="medicine.length"
                                                placeholder="Duljina trajanja terapije"
                                                data-toggle="tooltip"
                                                title="Početak uzimanja terapije / Izmjene / Promjene terapije"
                                            ></textarea>
                                            <label>Duljina trajanja terapije</label>
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-floating">
                                            <textarea
                                                type="text"
                                                class="form-control"
                                                :name="`medicines[${index}][effectiveness]`"
                                                v-model="medicine.effectiveness"
                                                placeholder="Učinkovitost"
                                                data-toggle="tooltip"
                                                title="Objetkivni / Subjektivni pokazatelji"
                                            ></textarea>
                                            <label>Učinkovitost</label>
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-floating">
                                            <textarea
                                                type="text"
                                                class="form-control"
                                                :name="`medicines[${index}][security]`"
                                                v-model="medicine.security"
                                                placeholder="Sigurnost"
                                                data-toggle="tooltip"
                                                title="Objetkivni / Subjektivni pokazatelji"
                                            ></textarea>
                                            <label>Sigurnost</label>
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-floating">
                                            <textarea
                                                type="text"
                                                class="form-control"
                                                :name="`medicines[${index}][adherence]`"
                                                v-model="medicine.adherence"
                                                data-toggle="tooltip"
                                                title="Zaboravljivost, poteškoće u prepoznavanju lijeka, poteškoće pri primjeni lijeka, problem u kupnji/ dostupnosti lijeka, nerazumijevanje uputa za primjenu lijeka, svjesno neuzimanje lijeka"
                                                placeholder="Adherencija"
                                            ></textarea>
                                            <label>Adherencija</label>
                                        </div>
                                    </div>
                                    <div class="col-md-auto align-self-center text-center">
                                        <div class="d-flex flex-column gap-1 align-items-center">
                                            <span class="drag-handle text-secondary fs-5" style="cursor: grab;" title="Povuci za promjenu redoslijeda"><i class="bi bi-grip-vertical"></i></span>
                                            <a @click="removeMedicine(index)" class="text-danger" style="cursor: pointer;" title="Ukloni lijek"><i class="bi bi-dash-circle"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                </div>
            </div>
        </div>
        <div class="col mb-3">
            <div class="card shadow-sm">
                <h5 class="card-header bg-problem text-white">
                    <ul class="list-inline m-0 d-flex align-items-center">
                        <li class="list-inline-item">
                            Terapijski problemi
                        </li>
                        <li class="list-inline-item">
                            <a @click="addProblem" id="add-problem" data-toggle="tooltip" title="Dodaj terapijski problem (Alt+T)">
                                <i class="bi bi-plus-circle"></i>
                            </a>
                        </li>
                        <li class="list-inline-item ms-auto">
                            <kbd class="bg-white text-dark opacity-75 rounded px-1" style="font-size:.65rem">Alt+T</kbd>
                        </li>
                    </ul>
                </h5>
                <div class="card-body text-muted bg-white">
                    <draggable v-model="form.problems" item-key="_key" handle=".drag-handle">
                        <template #item="{element: problem, index}">
                            <div class="problems" :id="`problems[${index}]`">
                                <div class="row g-2 mb-4">
                                    <div class="col-11 text-muted">
                                        <div class="form-floating">
                                            <select
                                                class="form-select text-problem w-100 bg-primary-subtle"
                                                :id="`problems[${index}][problem_id]`"
                                                :name="`problems[${index}][problem_id]`"
                                                v-model="problem.problem_id"
                                                required
                                            >
                                                <option value="" selected>-- Odaberi --</option>
                                                <optgroup
                                                    v-for="problemGroup in problemGroups"
                                                    :key="`pg-${problemGroup.id}`"
                                                    :label="`${problemGroup.number}. ${problemGroup.description}`"
                                                >
                                                    <option
                                                        v-for="problemItem in problemGroup.problem"
                                                        :key="`problem-item-${problemItem.id}`"
                                                        :value="problemItem.id"
                                                        v-text="`${problemItem.number} ${problemItem.description}`"
                                                    ></option>
                                                </optgroup>
                                            </select>
                                            <label>Problem</label>
                                        </div>
                                    </div>
                                    <div class="col-auto align-self-center text-center mb-2">
                                        <div class="d-flex flex-column gap-1 align-items-center">
                                            <span class="drag-handle text-secondary fs-5" style="cursor: grab;" title="Povuci za promjenu redoslijeda"><i class="bi bi-grip-vertical"></i></span>
                                            <a @click="removeProblem(index)" class="text-danger" style="cursor: pointer;" title="Ukloni terapijski problem"><i class="bi bi-dash-circle"></i></a>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-floating">
                                            <input
                                                :id="`problems[${index}][drug]`"
                                                :name="`problems[${index}][drug]`"
                                                v-model="problem.drug"
                                                type="text"
                                                class="form-control"
                                            >
                                            <label>Lijek</label>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-floating">
                                            <input
                                                :id="`problems[${index}][suggested_drug]`"
                                                :name="`problems[${index}][suggested_drug]`"
                                                v-model="problem.suggested_drug"
                                                type="text"
                                                class="form-control"
                                            >
                                            <label>Predloženi lijek/DP</label>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-floating">
                                            <input
                                                :id="`problems[${index}][target]`"
                                                :name="`problems[${index}][target]`"
                                                v-model="problem.target"
                                                type="text"
                                                class="form-control"
                                            >
                                            <label>Terapijski cilj</label>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-floating">
                                            <select
                                                class="form-select w-100"
                                                :id="`problems[${index}][intervention_type_id]`"
                                                :name="`problems[${index}][intervention_type_id]`"
                                                v-model="problem.intervention_type_id"
                                                required
                                            >
                                                <option value="" selected disabled>-- Odaberi --</option>
                                                    <option
                                                        v-for="interventionType in interventionTypes"
                                                        :key="`intervention-type-${interventionType.id}`"
                                                        :value="interventionType.id"
                                                        v-text="interventionType.description"
                                                    ></option>
                                            </select>
                                            <label>Vrsta intervencije</label>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-floating">
                                            <select
                                                :id="`problems[${index}][acceptedby]`"
                                                :name="`problems[${index}][acceptedby]`"
                                                v-model="problem.acceptedby"
                                                class="form-select w-100"
                                                required
                                            >
                                                <option value="" selected disabled>-- Odaberi --</option>
                                                <option value="Čekanje povratne informacije - nedefinirano">Čekanje povratne informacije - nedefinirano</option>
                                                <option value="Pacijent: Ne">Pacijent: Ne</option>
                                                <option value="Pacijent: Da">Pacijent: Da</option>
                                                <option value="Čekanje povratne informacije - pacijent">Čekanje povratne informacije - pacijent</option>
                                                <option value="Neuspješan kontakt s pacijentom">Neuspješan kontakt s pacijentom</option>
                                                <option value="LOM: Ne">LOM: Ne</option>
                                                <option value="LOM: Da">LOM: Da</option>
                                                <option value="Liječnik nedefinirani: Da">Liječnik nedefinirani: Da</option>
                                                <option value="Čekanje povratne informacije - liječnik">Čekanje povratne informacije - liječnik</option>
                                                <option value="Neuspješan kontakt s liječnikom">Neuspješan kontakt s liječnikom</option>
                                                <option value="Specijalist: Ne">Specijalist: Ne</option>
                                                <option value="Specijalist: Da">Specijalist: Da</option>
                                                <option value="Čekanje povratne informacije - specijalist">Čekanje povratne informacije - specijalist</option>
                                                <option value="Neuspješan kontakt sa specijalistom">Neuspješan kontakt sa specijalistom</option>
                                        </select>
                                        <label>Prihvaćeno od</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-floating">
                                            <textarea
                                                :id="`problems[${index}][intervention]`"
                                                :name="`problems[${index}][intervention]`"
                                                v-model="problem.intervention"
                                                type="text"
                                                rows="2"
                                                class="form-control"
                                            ></textarea>
                                            <label>Intervencija:</label>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <div class="form-floating">
                                            <select
                                                :id="`problems[${index}][status]`"
                                                :name="`problems[${index}][status]`"
                                                v-model="problem.status"
                                                class="form-select w-100"
                                            >
                                                <option value="" selected disabled>-- Odaberi --</option>
                                                <option value="0">Ne</option>
                                                <option value="1">Da</option>
                                            </select>
                                            <label>Riješeno</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                </div>
            </div>
        </div>
        <div class="col mb-3">
            <div class="card shadow-sm">
                <h5 class="card-header bg-cold text-white">
                    Dodatne informacije
                </h5>
                <div class="card-body text-muted">
                    <div class="form-floating">
                        <textarea
                            id="info"
                            name="info"
                            v-model="form.info"
                            type="text"
                            rows="2"
                            class="form-control mb-2"
                            placeholder="Dodatne informacije"
                        ></textarea>
                        <label>Dodatne informacije</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-auto text-end">
            <button type="submit" class="btn btn-primary">
                Spremi
            </button>
        </div>
    </form>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    components: { draggable },

    props: {
        consultation: Object,
        old: {
            type: Object,
            default: {},
            required: false,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        problemGroups: {
            type: Array,
            required: true,
        },
        interventionTypes: {
            type: Array,
            required: true,
        },
        // zaglavlje koje se unaprijed upisuje u "Povijest bolesti"
        historyPrefill: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            csrf: null,
            filteredDiseases: [],
            filteredDrugs: [],
            highlightedDisease: [],
            highlightedDrug: [],
            debouncedDiseaseQuery: _.debounce(this.findDisease, 1000),
            debouncedDrugQuery: _.debounce(this.findDrug, 1000),
            _keyCounter: 0,
            form: {
                diseases: [
                    {
                        _key: 1,
                        disease: null,
                        MKB10: null,
                        MKB11: null,
                        therapy_goal_achieved: null,
                    }
                ],
                history: null,
                relevant_medical_history: null,
                medicines: [
                    {
                        _key: 2,
                        drug: null,
                        ATK: null,
                        scheme: null,
                        length: null,
                        effectiveness: null,
                        security: null,
                        adherence: null,
                    }
                ],
                problems: [
                    {
                        _key: 3,
                        problem_id: null,
                        drug: null,
                        suggested_drug: null,
                        target: null,
                        intervention_type_id: null,
                        acceptedby: null,
                        intervention: null,
                        status: null,
                    }
                ],
                info: null,
            },
        }
    },

    created() {
        this._keyCounter = 3;
        this.csrf = document.querySelector('meta[name="csrf-token"]').content;

        if (_.isEmpty(this.old)) {
            this.form.history = this.historyPrefill;
        } else {
            // nakon neuspjele validacije zaglavlje već dolazi natrag u old
            this.form = {
                ...this.form,
                ...this.old,
            };
            // assign keys to items loaded from old input
            this.form.diseases.forEach(d => { if (!d._key) d._key = ++this._keyCounter; });
            this.form.medicines.forEach(m => { if (!m._key) m._key = ++this._keyCounter; });
            this.form.problems.forEach(p => { if (!p._key) p._key = ++this._keyCounter; });
        }
        window.addEventListener('beforeunload', this.handler)
    },

    mounted() {
        document.addEventListener('keydown', this.handleGlobalKeydown);
    },

    beforeUnmount() {
        document.removeEventListener('keydown', this.handleGlobalKeydown);
    },

    methods: {
        handleGlobalKeydown(e) {
            if (!e.altKey) return;
            switch (e.key.toLowerCase()) {
                case 'b':
                    e.preventDefault();
                    this.addDisease();
                    break;
                case 'l':
                    e.preventDefault();
                    this.addMedicine();
                    break;
                case 't':
                    e.preventDefault();
                    this.addProblem();
                    break;
            }
        },

        onDiseaseKeydown(e, index) {
            const suggestions = this.filteredDiseases[index];
            if (!suggestions || !suggestions.length) return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const current = this.highlightedDisease[index] ?? -1;
                this.highlightedDisease[index] = Math.min(current + 1, suggestions.length - 1);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                const current = this.highlightedDisease[index] ?? 0;
                this.highlightedDisease[index] = Math.max(current - 1, 0);
            } else if (e.key === 'Enter') {
                e.preventDefault();
                const idx = this.highlightedDisease[index];
                if (idx !== undefined && idx !== null && suggestions[idx]) {
                    this.selectDisease(index, suggestions[idx]);
                } else {
                    this.clearDisease(index);
                }
            } else if (e.key === 'Escape') {
                e.preventDefault();
                this.clearDisease(index);
            }
        },

        onDrugKeydown(e, index) {
            const suggestions = this.filteredDrugs[index];
            if (!suggestions || !suggestions.length) return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const current = this.highlightedDrug[index] ?? -1;
                this.highlightedDrug[index] = Math.min(current + 1, suggestions.length - 1);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                const current = this.highlightedDrug[index] ?? 0;
                this.highlightedDrug[index] = Math.max(current - 1, 0);
            } else if (e.key === 'Enter') {
                e.preventDefault();
                const idx = this.highlightedDrug[index];
                if (idx !== undefined && idx !== null && suggestions[idx]) {
                    this.selectDrug(index, suggestions[idx]);
                } else {
                    this.clearDrug(index);
                }
            } else if (e.key === 'Escape') {
                e.preventDefault();
                this.clearDrug(index);
            }
        },

        findDisease(index) {
            if(this.form.diseases[index].disease != '' && this.form.diseases[index].disease != null) {
                axios.get(route('disease.find', this.form.diseases[index].disease))
                .then(response => {
                    this.filteredDiseases[index] = response.data;
                    this.highlightedDisease[index] = null;
                })
                .catch(error => console.error('Error:', error));
            }

        },
        debouncedFindDisease(index) {
            this.debouncedDiseaseQuery(index);
        },
        selectDisease(index, suggestion) {
            const selectedDisease = this.form.diseases[index];
            selectedDisease.disease = suggestion.name;
            //MKB10
            if((selectedDisease.MKB10 == null || selectedDisease.MKB10 == '') && suggestion.MKB10 != null) {
                selectedDisease.MKB10 = suggestion.MKB10;
            }
            //MKB11
            if((selectedDisease.MKB11 == null || selectedDisease.MKB11 == '') && suggestion.MKB11 != null) {
                selectedDisease.MKB11 = suggestion.MKB11;
            }
            this.filteredDiseases[index] = [];
            this.highlightedDisease[index] = null;
        },
        clearDisease(index) {
            this.filteredDiseases[index] = [];
            this.highlightedDisease[index] = null;
        },
        addDisease() {
            this.form.diseases.push({
                _key: ++this._keyCounter,
                disease: null,
                MKB10: null,
                MKB11: null,
                therapy_goal_achieved: null,
            });
            const idx = this.form.diseases.length - 1;
            this.$nextTick(() => {
                const el = document.getElementById(`diseases[${idx}][disease]`);
                if (el) el.focus();
            });
        },
        removeDisease(index) {
            if(confirm("Jeste li sigurni da želite obrisati redak " + this.form.diseases[index].disease + "?")){
                this.form.diseases.splice(index, 1);
            }
        },
        findDrug(index) {
            if(this.form.medicines[index].drug != '' && this.form.medicines[index].drug != null) {
                axios.get(route('drug.find', this.form.medicines[index].drug))
                .then(response => {
                    this.filteredDrugs[index] = response.data;
                    this.highlightedDrug[index] = null;
                })
                .catch(error => console.error('Error:', error));
            }

        },
        debouncedFindDrug(index) {
            this.debouncedDrugQuery(index);
        },
        selectDrug(index, suggestion) {
            const selectedDrug = this.form.medicines[index];
            selectedDrug.drug = suggestion.name;
            //ATK
            if((selectedDrug.ATK == null || selectedDrug.ATK == '') && suggestion.ATK != null) {
                selectedDrug.ATK = suggestion.ATK;
            }
            this.filteredDrugs[index] = [];
            this.highlightedDrug[index] = null;
        },
        clearDrug(index) {
            this.filteredDrugs[index] = [];
            this.highlightedDrug[index] = null;
        },
        addMedicine() {
            this.form.medicines.push({
                _key: ++this._keyCounter,
                drug: null,
                ATK: null,
                scheme: null,
                length: null,
                effectiveness: null,
                security: null,
                adherence: null,
            });
            const idx = this.form.medicines.length - 1;
            this.$nextTick(() => {
                const el = document.querySelector(`[name="medicines[${idx}][drug]"]`);
                if (el) el.focus();
            });
        },
        removeMedicine(index) {
            if(confirm("Jeste li sigurni da želite obrisati redak " + this.form.medicines[index].drug + "?")){
                this.form.medicines.splice(index, 1);
            }
        },
        addProblem() {
            this.form.problems.push({
                _key: ++this._keyCounter,
                problem_id: null,
                drug: null,
                suggested_drug: null,
                target: null,
                intervention_type_id: null,
                acceptedby: null,
                intervention: null,
                status: null,
            });
            const idx = this.form.problems.length - 1;
            this.$nextTick(() => {
                const el = document.getElementById(`problems[${idx}][problem_id]`);
                if (el) el.focus();
            });
        },
        removeProblem(index) {
            if(confirm("Jeste li sigurni da želite obrisati terapijski problem?")){
                this.form.problems.splice(index, 1);
            }
        },
    },
}
</script>
